
import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "../../componenets/navbar/NavBar";
import LeadList from "../../componenets/leads/LeadList";

const Leads = () =>{
    // const role = useSelector((state) => state.user.userDetails.UserRole);
    const navigate = useNavigate();
    const { status } = useParams();
    const saved = localStorage.getItem('section2');
    const statusList = saved ? JSON.parse(saved) : [];
    useEffect(() => {
        if (!statusList.includes(status)) {
            navigate('/404'); // Redirect to the 404 page
        }
    }, [status, navigate]);

    // user check
    // useEffect(()=>{
    //     if(role && role !== "Super Admin"){
    //         navigate("/"); 
    //     }
    // },[role, navigate]);
    
    const navActive = useSelector((state) => state.navActive.value);
    useEffect(() => {
        const bodypd = document.getElementById('cbody');
        (navActive) ?  bodypd.classList.add('body-pd') : bodypd.classList.remove('body-pd');
    }, [navActive]);

    return(<>
        <NavBar />
        <div id="cbody" className="cbody">
            <div className="concard">
                <LeadList status_url={status}/>
            </div>
        </div>
    </>);
};

export default Leads;